module.exports = __webpack_public_path__ + "static/media/coffee-2.cf71def7.jpg";